import { createFileRoute } from "@tanstack/react-router";
import { NewsTemplate } from "~/features/news/NewsTemplate";
import { creditPurchaseCourseInfoQueryOptions } from "~/lib/queryOptions/creditPurchaseCourse";

export const Route = createFileRoute("/_authenticated/news")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(creditPurchaseCourseInfoQueryOptions),
  component: NewsTemplate,
});
